import { SxProps, Theme } from '@mui/material';

export const rankedTableStyles = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		gap: '8px',
		alignItems: 'center',
		width: '100%',
	},
	head: {
		color: 'rgba(255, 255, 255, 0.8)',
		padding: '0 12px',
		fontSize: '12px',
		lineHeight: '15px',
		fontWeight: 700,
		fontFamily: 'Montserrat',
		textTransform: 'uppercase',
		alignItems: 'center',
		height: '26px',
	},
	bannerWrapper: {
		backgroundColor: '#000000',
		padding: '16px 0',
		position: 'relative',
		borderRadius: '8px',
		height: '62px',
	},
	bannerImageWrapper: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%',
		height: '100%',
		filter: 'blur(10px)',
	},
	bannerTextWrapper: {
		position: 'absolute',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		borderRadius: '8px',
		border: '1px solid rgba(255, 255, 255, 0.1)',
		zIndex: 1,
		background: 'transparent',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '12px',
	},
	bannerTitle: {
		fontFamily: 'Montserrat',
		fontSize: '12px',
		lineHeight: '15px',
		fontWeight: 700,
		color: 'rgba(255, 255, 255, 0.8)',
		textTransform: 'uppercase',
	},
	bannerBtn: {
		color: 'white',
		minWidth: 'auto',
		fontWeight: 700,
		fontSize: '13px',
		lineHeight: '16px',
		fontFamily: 'Montserrat',
		padding: '10px 12px',
		borderRadius: '100px',
		textTransform: 'none',
		backgroundColor: 'rgba(52, 52, 52, 1)',
		border: '1px solid rgba(255, 255, 255, 0.1)',
		'&:hover': {
			backgroundColor: 'rgba(52, 52, 52, 0.5)',
		},
	},
	rowWrapper: {
		height: '69px',
		alignItems: 'center',
		padding: '0 12px',
		borderRadius: '8px',
		backgroundColor: 'rgba(255, 255, 255, 0.05)',
		transition: 'all 0.3s ease',
		color: 'white',
		position: 'relative',
		'&:hover': {
			transition: 'all 0.3s ease',
			scale: '1.025',
			backgroundColor: 'rgba(255, 255, 255, 0.1)',
		},
	},
};
